import { IComponentOptions, IController } from "angular";
import { getColorForIndex } from "@gtmhub/util";
import { Assignee, UnknownAssignee } from "@webapp/assignees/models/assignee.models";

type IStat = { value?: number; suffix: string };
export type IListItem = { value: number; suffix?: string; progressBarColor?: string; assignee: Assignee | UnknownAssignee };
export type IGenericListCardStats = {
  main: IStat;
  company: IStat;
  list: IListItem[];
};
const colors = ["#EB597B", "#37B9FF", "#8280FF", "#FACD14"];
export const setListItemColor = (index: number): string => getColorForIndex(index, colors);
class GenericListCardCtrl implements IController {
  cardTitle: string;
  icon: { name: string; size: string };
  stats: IGenericListCardStats;
  decimalPlaces: number;
}
export const GenericListCardComponent: IComponentOptions = {
  bindings: {
    cardTitle: "@",
    icon: "<",
    stats: "<",
    decimalPlaces: "<",
  },
  controller: GenericListCardCtrl,
  template: require("./generic-list-card.html"),
};
